export function fieldsViewSchema( entity ) {
    switch (entity) {
        default:
            return []
    }
}
export function fieldsListSchema( entity ) {
    switch (entity) {
        default:
            return []
    }
}